import dayjs from 'dayjs'
import { fetchExhibitionList, fetchExhibitionPage } from '~/api/exhibition'
import { fetchNewsHomePageList } from '~/api/newsApi'
import { fetchIndustryGetAll } from '~/api/industry'
import { fetchPageBanner } from '~/api/bannerApi'
import { fetchInnerChainPage } from '~/api/innerChain'
import _ from 'lodash'
import { useLang } from '~/composables/useLang'

export const useHome = async (_lang: ELocale) => {
  const { lang, $t } = useLang(_lang)
  const globalStore = useGlobalStore()
  const keyword = ref('')
  const keywordError = ref(false)
  const keywordPlaceholder = ref($t('home.top_container.inputPlaceholder'))
  const innerChainActive = ref(0)
  const apiErrorList = ref<any[]>([])

  const currentDate = dayjs().add(7, 'days').format('YYYY-MM-DD')

  // area国内传cityId,国际传areaId(国家id);type 1国内, 0国际
  const getAreaFairList = (area: string, type: number) => {
    let params: any = {
      locale: lang,
      selectTimeType: 1,
      pageNum: 1,
      pageSize: 2,
      time: currentDate,
      sortStr: 'scale',
      sortType: 'asc'
    }
    if (type == 1) params['cityId'] = area
    if (type == 0) params['area'] = area

    return fetchExhibitionList(params)
  }
  const getNewsList = (newsType?: string, pageSize = 10) => {
    // 咨询类型 展会资讯 industry 行业动态 industryNews 展会政策 policy 展会知识 knowledge
    return fetchNewsHomePageList({
      locale: lang,
      newsType,
      pageNum: 1,
      pageSize
    })
  }

  //   console.log('lang =>', lang);
  const { data } = await useAsyncData(`home-${lang}`, async () => {
    return await batchProcessRequests(
      [
        () => fetchIndustryGetAll({ locale: lang }),
        () => fetchPageBanner({ type: 0, channel: 0 }),
        () =>
          fetchExhibitionList({
            locale: lang,
            selectTimeType: 1,
            recommond: '1',
            pageNum: 1,
            pageSize: 20,
            sortScale: 'desc'
          }),
        () => getAreaFairList('1123', 1),
        () => getAreaFairList('1051', 1),
        () => getAreaFairList('1252', 1),
        () => getAreaFairList('73', 0),
        () => getAreaFairList('9', 0),
        () => getAreaFairList('127', 0),
        () => getNewsList('1', 20),
        () =>
          fetchExhibitionPage({
            locale: lang,
            pageNum: 1,
            pageSize: 10
          }),
        () =>
          fetchInnerChainPage({
            category: '热门地区',
            pageSize: 16
          }),
        () =>
          fetchInnerChainPage({
            category: '热门行业',
            pageSize: 16
          }),
        () =>
          fetchInnerChainPage({
            category: '热门展会',
            pageSize: 16
          }),
        // @ts-ignore
        () => globalStore.getLinks()
      ],
      { parallel: true }
    )
  })

  const [
    industryRes,
    bannerRes,
    hotFairRes,
    shFairRes,
    bjFairRes,
    szFairRes,
    dgFairRes,
    rbFairRes,
    mgFairRes,
    newsRes,
    policyNewsRes,
    innerChainAreaRes,
    innerChainIndustryRes,
    innerChainExhRes
  ] = data.value || []

  let industry: any[] = []
  if (_.get(industryRes, 'code') === ResponseCode.SUCCESS) {
    industry = industryRes?.data
  }

  const banner: any[] = []
  if (_.get(bannerRes, 'code') === ResponseCode.SUCCESS) {
    for (let i = 0; i < bannerRes?.data.length; i++) {
      const url = bannerRes?.data[i].bannerUrlList
      const link = bannerRes?.data[i].bannerLinkListPc
      banner.push({
        url,
        link
      })
    }
  }

  let hotFair: Record<string, any> = {}
  if (_.get(hotFairRes, 'code') === ResponseCode.SUCCESS) {
    hotFair = hotFairRes?.data
  } else {
    apiErrorList.value.push({
      pageUrl: 'home',
      url: '/api/exhibition/list',
      code: hotFairRes?.code, 
      message: hotFairRes?.message || hotFairRes?.errorMessage 
    })
    handleNodeServerError(JSON.stringify(apiErrorList.value))
  }

  let shFair: Record<string, any> = {}
  if (_.get(shFairRes, 'code') === ResponseCode.SUCCESS) {
    shFair = shFairRes?.data
  } else {
    apiErrorList.value.push({ code: shFairRes?.code, message: shFairRes?.message })
    // handleNodeServerError(JSON.stringify(apiErrorList.value));
  }

  let bjFair: Record<string, any> = {}
  if (_.get(bjFairRes, 'code') === ResponseCode.SUCCESS) {
    bjFair = bjFairRes?.data
  } else {
    apiErrorList.value.push({ code: bjFairRes?.code, message: bjFairRes?.message })
    // handleNodeServerError(JSON.stringify(apiErrorList.value));
  }

  let szFair: Record<string, any> = {}
  if (_.get(szFairRes, 'code') === ResponseCode.SUCCESS) {
    szFair = szFairRes?.data
  } else {
    apiErrorList.value.push({ code: szFairRes?.code, message: szFairRes?.message })
    // handleNodeServerError(JSON.stringify(apiErrorList.value));
  }

  let dgFair: Record<string, any> = {}
  if (_.get(dgFairRes, 'code') === ResponseCode.SUCCESS) {
    dgFair = dgFairRes?.data
  } else {
    apiErrorList.value.push({ code: dgFairRes?.code, message: dgFairRes?.message })
    // handleNodeServerError(JSON.stringify(apiErrorList.value));
  }

  let rbFair: Record<string, any> = {}
  if (_.get(rbFairRes, 'code') === ResponseCode.SUCCESS) {
    rbFair = rbFairRes?.data
  } else {
    apiErrorList.value.push({ code: rbFairRes?.code, message: rbFairRes?.message })
    // handleNodeServerError(JSON.stringify(apiErrorList.value));
  }

  let mgFair: Record<string, any>[] = []
  if (_.get(mgFairRes, 'code') === ResponseCode.SUCCESS) {
    mgFair = mgFairRes?.data.records
  } else {
    apiErrorList.value.push({ code: mgFairRes?.code, message: mgFairRes?.message })
    // handleNodeServerError(JSON.stringify(apiErrorList.value));
  }

  let news: Record<string, any> = []
  if (_.get(newsRes, 'code') === ResponseCode.SUCCESS) {
    news = newsRes?.data.records.map(
      (item: { newsId: any; viewUrl: any; newsName: any; publishTime: any }) => {
        const isToday = dayjs().diff(dayjs(item.publishTime), 'days')
        const format = isToday > 1 ? 'MM-DD HH:mm' : 'HH:mm'

        return {
          newsId: item.newsId,
          viewUrl: item.viewUrl,
          newsName: item.newsName,
          createTime: dayjs(item.publishTime).format(format)
        }
      }
    )
  }

  let policyNews: Record<string, any>[] = []
  if (_.get(policyNewsRes, 'code') === ResponseCode.SUCCESS) {
    policyNews = policyNewsRes?.data.records.map(
      (item: { exhibitionId: any; exhibitionName: any; startTime: any }) => ({
        exhibitionId: item.exhibitionId,
        exhibitionName: item.exhibitionName,
        startTime: item.startTime
      })
    )
  }

  let innerChainAreaList: any[] = []
  let innerChainIndustryList: any[] = []
  let innerChainExhList: any[] = []

  if (_.get(innerChainAreaRes, 'code') === ResponseCode.SUCCESS) {
    innerChainAreaList = innerChainAreaRes?.data.records
  }

  if (_.get(innerChainIndustryRes, 'code') === ResponseCode.SUCCESS) {
    innerChainIndustryList = innerChainIndustryRes?.data.records
  }

  if (_.get(innerChainExhRes, 'code') === ResponseCode.SUCCESS) {
    innerChainExhList = innerChainExhRes?.data.records
  }
  //   console.log('725-',apiErrorList.value)
  //   if (apiErrorList.value.length > 0) handleNodeServerError(JSON.stringify(apiErrorList.value));

  const handleSearch = _.debounce(
    () => {
      if (!/^[0-9a-zA-Z\u4E00-\u9FA5 ()（）]+$/.test(keyword.value)) {
        keywordError.value = true
        ElMessage.error({
          message: $t('menu.keyword_error1'),
          offset: 500
        })
        return
      } else {
        keywordError.value = false
      }
      if (keyword.value.length > 50) {
        keywordError.value = true
        ElMessage.error({
          message: $t('menu.keyword_error2'),
          offset: Math.ceil(window.innerHeight / 2)
        })
        return
      }
      if (keyword.value) {
        window.open(`/exhibition/?keyword=${keyword.value}`, '_blank')
      } else {
        ElMessage.warning($t('menu.keywordPlaceholder1'))
      }
    },
    500,
    { leading: true }
  )

  const handleHotTab = (e: any) => {
    innerChainActive.value = e
  }

  const handleKeywordInput = () => {
    if (!keyword.value) {
      keywordError.value = false
      keywordPlaceholder.value = $t('menu.keywordPlaceholder1')
    } else if (keyword.value.length > 50) {
      keywordError.value = true
      keywordPlaceholder.value = $t('menu.keyword_error2')
    } else {
      keywordError.value = !/^[a-zA-Z\u4E00-\u9FA5 ()（）]+$/.test(keyword.value)
      keywordPlaceholder.value = $t('menu.keywordPlaceholder3')
    }
  }

  const subIndustry = (idx: number) => {
    const index = idx % 5
    switch (index) {
      case 0:
        return 'transform: translateX(-8%);'
      case 1:
        return 'transform: translateX(-16%);'
      case 2:
        return 'transform: translateX(-42%);'
      case 3:
        return 'transform: translateX(-22%);'
      case 4:
        return 'transform: translateX(-58%);'
    }
  }

  const get = _.get<any, string>

  return {
    $t,
    keyword,
    keywordError,
    keywordPlaceholder,
    innerChainActive,
    lang,
    apiErrorList,
    industry,
    banner,
    hotFair,
    shFair,
    bjFair,
    szFair,
    dgFair,
    rbFair,
    mgFair,
    news,
    policyNews,
    innerChainAreaList,
    innerChainIndustryList,
    innerChainExhList,
    handleSearch,
    handleHotTab,
    handleKeywordInput,
    subIndustry,
    get
  }
}
